import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  fetchPortalOverview, fetchPortalReports, fetchPortalVulnerabilities,
  fetchPortalNotifications, fetchSupportTickets, createSupportTicket, markPortalNotificationRead
} from '../services/portalService';

export const loadPortalData = createAsyncThunk('portal/loadAll', async (orgName, { getState }) => {
  const org = orgName || getState().portalAuth.orgName || 'Client';
  const [overview, reports, vulnerabilities, notifications, tickets] = await Promise.all([
    fetchPortalOverview(org),
    fetchPortalReports(),
    fetchPortalVulnerabilities(),
    fetchPortalNotifications(),
    fetchSupportTickets()
  ]);
  return { overview, reports, vulnerabilities, notifications, tickets };
});

export const submitTicket = createAsyncThunk('portal/submitTicket', async ({ subject, message }) => createSupportTicket(subject, message));
export const markNotificationRead = createAsyncThunk('portal/markNotificationRead', async (id) => markPortalNotificationRead(id));

const portalSlice = createSlice({
  name: 'portal',
  initialState: {
    status: 'idle', error: null,
    overview: null, reports: [], vulnerabilities: [], notifications: [], tickets: []
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadPortalData.pending, (state) => { state.status = 'loading'; })
      .addCase(loadPortalData.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.overview = action.payload.overview;
        state.reports = action.payload.reports;
        state.vulnerabilities = action.payload.vulnerabilities;
        state.notifications = action.payload.notifications;
        state.tickets = action.payload.tickets;
      })
      .addCase(loadPortalData.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(submitTicket.fulfilled, (state, action) => {
        state.tickets.unshift(action.payload);
      })
      .addCase(markNotificationRead.fulfilled, (state, action) => {
        const n = state.notifications.find((x) => x.id === action.payload.id);
        if (n) n.read = true;
      });
  }
});

export default portalSlice.reducer;
